var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "date-cell",
      class: _vm.field.alignment,
      on: { dblclick: _vm.enableEdit },
    },
    [
      _vm.editing
        ? [
            !_vm.includeTime
              ? _c("a-date-picker", {
                  ref: "datePicker",
                  attrs: { value: _vm.getDateValue(), format: _vm.format },
                  on: { change: _vm.onDateChange, ok: _vm.disableEdit },
                })
              : _c("a-date-picker", {
                  ref: "dateTimePicker",
                  attrs: {
                    value: _vm.getDateTimeValue(),
                    "show-time": { format: _vm.timeFormat },
                    format: _vm.format + " " + _vm.timeFormat,
                  },
                  on: { change: _vm.onDateTimeChange, ok: _vm.disableEdit },
                }),
          ]
        : [_vm._v("\n        " + _vm._s(_vm.formattedValue) + "\n    ")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }